'use strict';

/* jshint -W098 */
angular.module('mean.builders').controller('BuilderMultiReviewController', ['$scope', 'MeanUser', 'Global', 'BidBuilderReview', 'Users', '$filter', '$location', 'taskTotalsService', 'tradeCodeService',
  function($scope, MeanUser, Global, BidBuilderReview, Users, $filter, $location, taskTotalsService, tradeCodeService) {
    $scope.global = Global;
    $scope.package = {
      name: 'builders'
    };

    $scope.user = MeanUser.user;
    $scope.bids = [];
    $scope.bid_menu = [];
    $scope.trade_code = tradeCodeService.getCode($scope.user.trade[0]);
    
    $scope.init = function() {
        $scope.bid = BidBuilderReview.get();

        if(!$scope.bid || !$scope.bid._id){
            $location.path('home');
            return;
        }

        var menu = $scope.bid.project_plan;

        _.each($scope.bid.plan_codes, function(plan_code) {
            $scope.bid_menu.push({
                item: plan_code.code
            });
        });

        $scope.trades = [];

        //build a selector of trades
        $scope.bid.bidding_trades.forEach(function(bid) {
            if($scope.trades.indexOf(bid.trade) === -1)
              $scope.trades.push(bid.trade);
        });
    };

    $scope.changeTrade = function(selectedTrade) {
        $scope.bids = [];
        var bids = $filter('filter')($scope.bid.bidding_trades, {'trade': selectedTrade}, true);

        //use this spot to refactor the data for the view
        bids.forEach(function(bid) {
            //var filtered = $filter('filter')(bid.task_list, {'trade': tradeCodeService.getCode(selectedTrade)}, true)
            //$scope.applyCalculations(filtered, bid.costs);
            $scope.bid_menu.forEach(function(menu) {
                $scope.updateTablePlan(bid, menu.item);
                $scope.bids.push(bid);
            });
        });
    };

    $scope.updateTablePlan = function(my_bid, plan) {
        var bid_tasks = [];
        var current_trade = tradeCodeService.getCode(my_bid.trade);

        my_bid.task_list.forEach(function(task, index){
            if( task.trade === current_trade){
                my_bid.bid.forEach(function(bid, ii) {
                    
                    if(bid.task_id === task._id) {
                        if(bid.plan_code === plan) {
                            bid.subtasks.forEach(function(subtask, si) {
                                task.subtasks.forEach(function(tsub, tsi) {
                                    if(subtask.task_id === tsub._id) {
                                        tsub.quantity = Number(subtask.quantity);
                                        tsub.bid_hours = Number(subtask.bid_hours);
                                        tsub.labor = Number(subtask.labor);
                                    }
                                });
                                if(!subtask.equipment) subtask.equipment = [];
                                subtask.equipment.forEach(function(eq, eidx) {
                                    task.subtasks[si].equipment.forEach(function(teq, teidx) {
                                        if(eq.equipment_id === teq._id && teq._id) {
                                            teq.quantity = Number(eq.quantity);
                                            if(eq.price_per_order)
                                              teq.price_per_order = Number(eq.price_per_order);
                                            if(eq.delivery_price)
                                              teq.delivery_price = Number(eq.delivery_price);
                                        }
                                    });
                                });
                                if(!subtask.materials) subtask.materials = [];
                                subtask.materials.forEach(function(mq, midx) {
                                    task.subtasks[si].materials.forEach(function(tmq, tmidx) {
                                        if(mq.material_id === tmq._id && tmq._id) {
                                            tmq.quantity = Number(mq.quantity);
                                            if(mq.price_per_order)
                                              tmq.price_per_order = Number(mq.price_per_order);
                                            if(mq.delivery_price)
                                              tmq.delivery_price = Number(mq.delivery_price);
                                        }
                                    });
                                });
                            });
                        } else {
                            //this bid does not match the current plan but it matches the task.
                            //we need to see if there is a plan/bid for this task.
                            //if there is we need to leave it alone, if there is not
                            //then we should clear it out.
                            var bid_found = false;
                            for(var i=0; i<my_bid.bid.length; i=i+1){
                                if(my_bid.bid[i].task_id === task._id &&
                                    my_bid.bid[i].plan_code === plan)
                                  bid_found = true;
                            }

                            if(!bid_found){
                                task.subtasks.forEach(function(sub) {
                                    sub.quantity = 0;
                                    sub.bid_hours = 0;
                                    sub.materials.forEach(function(mat){
                                        mat.quantity = 0;
                                        mat.materials_subtotal = 0;
                                        mat.materials_dev_subtotal = 0;
                                    });
                                    sub.equipment.forEach(function(eq) {
                                        eq.quantity = 0;
                                        eq.equipment_subtotal = 0;
                                        eq.equipment_dev_subtotal = 0;
                                    });
                                });
                            }
                        }
                    }
                });

                bid_tasks.push(task);
            }
        });

        $scope.applyCalculations(bid_tasks, my_bid.costs);
    };

    $scope.applyCalculations = function(tasks, costs, plan) {
        taskTotalsService.getCalculations(tasks, costs);

        $scope.bid_total = tasks.bid_total;
        $scope.bid_general_liability = tasks.bid_general_liability;
        $scope.bid_total_labor = tasks.bid_total_labor;
        $scope.bid_total_materials = tasks.bid_total_materials;
        $scope.bid_materials_taxes = tasks.bid_materials_taxes;
        $scope.bid_materials_subtotal = tasks.bid_materials_subtotal;
        $scope.bid_total_equipment = tasks.bid_total_equipment;
        $scope.bid_equipment_subtotal = tasks.bid_equipment_subtotal;
        $scope.bid_equipment_taxes = tasks.bid_equipment_taxes;
        $scope.bid_direct_labor = tasks.bid_direct_labor;
        $scope.bid_mark_up = tasks.bid_mark_up;
        $scope.bid_workers_comp = tasks.bid_workers_comp;
        $scope.bid_payroll_taxes = tasks.bid_payroll_taxes;
        $scope.bid_overhead_and_profit = tasks.bid_overhead_and_profit;
        $scope.bid_total_hours_allowed = tasks.bid_total_hours_allowed;
        $scope.bid_direct_labor = tasks.bid_direct_labor;
        $scope.bid_workers_comp = tasks.bid_workers_comp;
        $scope.bid_payroll_taxes = tasks.bid_payroll_taxes;

        $scope.bid_menu.forEach(function(bid) {
            if(plan === bid.item) {
                if(bid.item !== 'Cover') {
                    console.log('found the current item ' + bid.item);
                    bid.bid_total = tasks.bid_total;
                    bid.bid_direct_labor = tasks.bid_direct_labor;
                    bid.bid_total_labor = tasks.bid_total_labor;
                    bid.bid_total_materials = tasks.bid_total_materials;
                    bid.bid_total_equipment = tasks.bid_total_equipment;
                    bid.bid_general_liability = tasks.bid_general_liability;
                    bid.bid_workers_comp = tasks.bid_workers_comp;
                    bid.bid_payroll_taxes = tasks.bid_payroll_taxes;
                    bid.bid_overhead_and_profit = tasks.bid_overhead_and_profit;
                    bid.bid_total_hours_allowed = tasks.bid_total_hours_allowed;
                }
            }
        });
    };

  }
]);


// WEBPACK FOOTER //
// ./packages/custom/builders/public/controllers/builderMultiReview.js